import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ComplianceDocumentsResponse } from '../../../models/asset-details-response.model';
import { CommonModule } from '@angular/common';
import { isExpired, isExpiringSoon } from '../../../../../_shared/helpers/license-status.helper';
import { LookupLabelPipe } from '../../../../../_shared/pipes/lookup-label.pipe';

type DocumentStatus = 'valid' | 'expiring-soon' | 'non-compliant';

@Component({
  selector: 'app-compliance-document-row',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, LookupLabelPipe],
  templateUrl: './compliance-document-row.component.html',
  styleUrl: './compliance-document-row.component.scss'
})
export class ComplianceDocumentRowComponent {
  private readonly transloco: TranslocoService = inject(TranslocoService);

  @Input() row: ComplianceDocumentsResponse;
  @Output() viewDocument = new EventEmitter<ComplianceDocumentsResponse>();
  @Output() editDocument = new EventEmitter<ComplianceDocumentsResponse>();
  @Output() deleteDocument = new EventEmitter<ComplianceDocumentsResponse>();

  get status(): DocumentStatus {
    const expiry = this.row.expirationDate;
    if (!expiry) return 'valid';
    if (isExpired(expiry)) return 'non-compliant';
    if (isExpiringSoon(expiry)) return 'expiring-soon';
    return 'valid';
  }

  get isDocumentExpired(): boolean {
    return this.status === 'non-compliant';
  }

  get statusLabel(): string {
    switch (this.status) {
      case 'non-compliant': return this.transloco.translate('assetOverview.complianceRow.status.nonCompliant');
      case 'expiring-soon': return this.transloco.translate('assetOverview.complianceRow.status.expiringSoon');
      default: return this.transloco.translate('assetOverview.complianceRow.status.valid');
    }
  }

  onViewClick(row: ComplianceDocumentsResponse): void {
    this.viewDocument.emit(row);
  }

  onEditClick(row: ComplianceDocumentsResponse): void {
    this.editDocument.emit(row);
  }

  onDeleteClick(row: ComplianceDocumentsResponse): void {
    this.deleteDocument.emit(row);
  }
}